import Api, { make, Response } from 'src/services/api'

import { Airport, Id } from 'src/types'

interface GetAirportProps {
  name: Id
  organization_id: Id
  size?: number
}

async function getAirport({
  name,
  organization_id,
  size = 5
}: GetAirportProps): Promise<Response<Airport[]>> {
  return make<Airport[]>({
    axiosCall: Api.get(
      `organizations/${organization_id}/airports?name=${name}&size=${size}`
    )
  })
}

export default { getAirport }
